export default "__VITE_ASSET__85aa2c19__"